import { ReceivablePayloadResponse } from '@types'
import { MockFactory } from '@tino-frontend/mocks'

export const receivablesDetailsAPIMock =
  new MockFactory<ReceivablePayloadResponse>({
    total_collected: 20000,
    collects: [
      {
        date: '2022-10-05T00:00:00Z',
        arrangement: [
          {
            name: 'Redecard - Visa Crédito',
            amount: 10000,
          },
          {
            name: 'Redecard - Visa Débito',
            amount: 10000,
          },
        ],
      },
    ],
  })
